import { Body } from 'breeze-intelligence-kit';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { useCreditCheck } from 'policy-lib';
import { useEnrichList } from './useEnrichList';
import { LiveEnrichmentDisclaimer } from '../LiveEnrichmentDisclaimer';
import { ModalBulk } from '../ModalBulk/ModalBulk';
import { OverwriteSetting } from '../OverwriteSetting';
import { ListEnrichmentAssociatedRecords } from './ListEnrichmentAssociatedRecords';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ListEnrichmentModalContent = ({
  isOpen,
  onClose,
  onCloseComplete
}) => {
  const {
    enrichAssociations,
    isLoading,
    isContactEnrichment,
    name,
    objectTypeId,
    onSubmit,
    onToggleEnrichAssociations,
    overwrite,
    setOverwrite,
    size
  } = useEnrichList();
  const action = 'DATASET_ENRICHMENT';
  const {
    isAuthorized
  } = useCreditCheck({
    action,
    numberOfOperations: size
  });
  const handleSubmit = event => {
    event.preventDefault();
    onSubmit();
  };
  return /*#__PURE__*/_jsx(ModalBulk, {
    isLoading: isLoading,
    isOpen: isOpen,
    onClose: onClose,
    onCloseComplete: onCloseComplete,
    children: /*#__PURE__*/_jsxs("form", {
      onSubmit: handleSubmit,
      children: [/*#__PURE__*/_jsx(ModalBulk.Header, {
        children: /*#__PURE__*/_jsx(ModalBulk.Heading, {
          truncate: true,
          children: name
        })
      }), /*#__PURE__*/_jsxs(ModalBulk.Body, {
        children: [/*#__PURE__*/_jsx(ModalBulk.UsageAlert, {
          action: action,
          numberOfOperations: size
        }), /*#__PURE__*/_jsxs(Body, {
          children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
            "data-test-id": "list-enrich-modal-body",
            message: "enrichmentProperties.modals.enrichList.body",
            options: {
              count: size
            }
          }), ' ', /*#__PURE__*/_jsx(FormattedMessage, {
            message: "enrichmentProperties.modals.enrichCycleMessage"
          })]
        }), /*#__PURE__*/_jsx(ModalBulk.UsageEstimate, {
          action: action,
          numberOfOperations: size
        }), /*#__PURE__*/_jsx(ModalBulk.Usage, {
          action: action
        }), /*#__PURE__*/_jsx(ModalBulk.UsageDisclaimer, {
          action: action,
          isVisible: isAuthorized
        }), /*#__PURE__*/_jsx(ListEnrichmentAssociatedRecords, {
          enrichAssociations: enrichAssociations,
          objectTypeId: objectTypeId,
          onToggleEnrichAssociations: onToggleEnrichAssociations
        }), /*#__PURE__*/_jsx(OverwriteSetting, {
          checked: overwrite,
          id: "enrichList-overwrite",
          onChange: setOverwrite
        }), /*#__PURE__*/_jsx(LiveEnrichmentDisclaimer, {
          isContactEnrichment: isContactEnrichment
        })]
      }), /*#__PURE__*/_jsx(ModalBulk.Footer, {
        children: /*#__PURE__*/_jsxs(ModalBulk.FooterActions, {
          children: [/*#__PURE__*/_jsx(ModalBulk.ButtonUsageCheck, {
            action: action,
            isLoading: isLoading,
            numberOfOperations: size,
            type: "submit",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "enrichmentProperties.modals.enrichRecords.enrich"
            })
          }), /*#__PURE__*/_jsx(ModalBulk.ButtonCancel, {
            onClick: onClose
          })]
        })
      })]
    })
  });
};